define("ExternalVendor.Inventory.View", [
  "SCView",
  "ExternalVendor.Inventory.SS2Model",
  "sdb_ext_vendor_inventory.tpl",
  "Utils",
  "SDB.SDBLocations.Model",
], function (
  SCViewModule,
  ExternalVendorInventorySS2Model,
  sdb_ext_vendor_inventory_tpl,
  Utils,
  SDBLocationsModel
) {
  var SCView = SCViewModule.SCView;

  var ExternalVendorInveltoryView = function ExternalVendorInveltoryView(
    options
  ) {
    SCView.call(this);
    var self = this;

    this.options = options || {};
    this.template = sdb_ext_vendor_inventory_tpl;

    this.PDP = this.options.container.getComponent("PDP");
    this.model = ExternalVendorInventorySS2Model.getInstance();
    this.LocationsModel = SDBLocationsModel.getInstance();
    var recordTypesWithInventory = this.model.recordTypesWithInventory;
    var recordTypesNotPurchasable = this.model.recordTypesNotPurchasable;

    if (this.options.cartpage) {
      this.isCartPage = true;
      this.Cart = this.options.container.getComponent("Cart");
      this.itemModel = this.options.cartLine;
    }

    this.getCurrentQuantity = function () {
      return this.PDP.getItemInfo()
        ? this.PDP.getItemInfo().quantity
        : Utils.parseUrlOptions(Backbone.history.location.href).quantity || 1;
    };

    this.getItemInternalid = function () {
      return this.PDP.getItemInfo()
        ? this.PDP.getItemInfo().item.internalid
        : null;
    };

    this.quantity = this.getCurrentQuantity();

    this.attributes = {
      class: "sdb_ext_vendor_inventory",
      id: "sdb_ext_vendor_inventory",
    };

    this.getShoppingExperience = function () {
      return (
        this.LocationsModel.get("shoppingExperience") ||
        this.LocationsModel.getShoppingExperience()
      );
    };

    this.getLocation = function () {
      return (
        this.LocationsModel.get("location") ||
        this.LocationsModel.getSelectedLocation()
      );
    };

    this.getContext = function getContext() {
      var loading = false;
      var shoppingExperience = this.getShoppingExperience();
      var location =
        shoppingExperience !== "online" ? this.getLocation() : "Fedco";
      if (!this.isCartPage) {
        // calculate stock levels as in PDP
        var stockClass = "";
        var internalid = this.getItemInternalid();
        var internalStock = this.model.get("itemInternalStock");
        var stockInfo = _.findWhere(internalStock, { item_id: internalid })
          ? _.findWhere(internalStock, { item_id: internalid })
          : this.PDP.getStockInfo();
        var externalTotalStock = location
          ? this.model.get("totalStock")
          : this.model.get("stockBehaviorDataTotalStock");
        var externalStock = this.model.get("totalExternalStock") || 0;
        var earlierShipTimeData =
          stockInfo &&
          this.quantity > stockInfo.stock &&
          this.quantity <= stockInfo.stock + externalStock &&
          this.model.getEarlierShipTime(this.quantity - stockInfo.stock);
        var greaterShipTime =
          stockInfo &&
          this.quantity > stockInfo.stock + externalStock &&
          this.model.getLatestShipTime(
            this.quantity - stockInfo.stock - externalStock
          );
        var shipTime = earlierShipTimeData
          ? earlierShipTimeData.time
          : greaterShipTime
            ? greaterShipTime
            : "";

        var isInvalid = function isInvalid(value) {
          if (value === undefined || value === null || value === "") {
            return true;
          }
          return false;
        };

        if (
          isInvalid(stockInfo) ||
          (isInvalid(externalTotalStock) && isInvalid(shipTime))
        ) {
          loading = true;
        }
      } else {
        // if its in Cart Page Model attributes are being used instead
        var stockLines = this.model.get("linesAndStockHelper");
        var itemId = this.itemModel && this.itemModel.id;
        var itemStocks = _.findWhere(stockLines, { item_id: itemId });
        var itemRecordType = this.itemModel && this.itemModel.get("itemtype");
        if (!itemStocks) {
          if (
            recordTypesNotPurchasable.indexOf(itemRecordType.toLowerCase()) !==
            -1
          ) {
            var stockBehaviorData = {};
            stockClass = "in-stock";
            stockBehaviorData.behaviour = "In Stock";
            stockBehaviorData.isInStock = true;
            stockBehaviorData.stockDescription = "In stock";
            this.model.set({
              stockBehaviorDataTotalStock: stockBehaviorData.totalStock || 0,
            });
            return {
              totalStock: stockBehaviorData.totalStock || 0,
              stockClass: stockClass,
              stockDescription: stockBehaviorData.stockDescription,
              isInStock: stockBehaviorData.isInStock,
              behavior: stockBehaviorData.behavior,
              loading: false,
              internalStock: 0,
              externalStock: 0,
            };
          }
          loading = true;
          return;
        }
        this.quantity = itemStocks.quantity || 1;
        var extInventoryJson = localStorage.getItem(
          "custbody_sdb_store_ext_inv_data"
        );
        var intInventoryJson = localStorage.getItem(
          "custbody_sdb_store_int_inv_data"
        );
        if (typeof extInventoryJson === "string") {
          extInventoryJson = JSON.parse(extInventoryJson);
        } else if (!extInventoryJson) {
          extInventoryJson = {};
        }

        if (typeof intInventoryJson === "string") {
          intInventoryJson = JSON.parse(intInventoryJson);
        } else if (!intInventoryJson) {
          intInventoryJson = {};
        }
        var shipTimeTable = extInventoryJson;
        var intShipTimeTable = intInventoryJson;
        var lastPosition =
          shipTimeTable[itemId] && shipTimeTable[itemId].length - 1;
        var lastIntPosition =
          intShipTimeTable[itemId] && intShipTimeTable[itemId].length - 1;
        if (shipTimeTable[itemId] && shipTimeTable[itemId].length)
          var extShipTime = shipTimeTable[itemId][lastPosition]
            ? shipTimeTable[itemId][lastPosition].shipping_eta
            : "";
        if (intShipTimeTable[itemId] && intShipTimeTable[itemId].length)
          var intShipTime = intShipTimeTable[itemId][lastIntPosition]
            ? intShipTimeTable[itemId][lastIntPosition].shipping_eta
            : "";
        if (extShipTime && intShipTime) {
          var shipTimeText = shipTimeTable[itemId][lastPosition].shipping_eta
            ? shipTimeTable[itemId][lastPosition].shipping_eta.text
            : "";
          var intShipTimeText = intShipTimeTable[itemId][lastIntPosition]
            .shipping_eta
            ? intShipTimeTable[itemId][lastIntPosition].shipping_eta.text
            : "";
          var shipTime = this.model.compareETAs(shipTimeText, intShipTimeText)
            ? shipTimeText
            : intShipTimeText;
        } else if (!intShipTime && extShipTime) {
          var shipTime = shipTimeTable[itemId][lastPosition].shipping_eta
            ? shipTimeTable[itemId][lastPosition].shipping_eta.text
            : "";
        } else if (!extShipTime && intShipTime) {
          var shipTime = intShipTimeTable[itemId][lastIntPosition].shipping_eta
            ? intShipTimeTable[itemId][lastIntPosition].shipping_eta.text
            : "";
        }
      }

      var stockBehaviorData = {};
      if (this.isCartPage && this.model.get("linesAndStockHelper")) {
        stockBehaviorData = this.model.getStockState({
          internalStock: itemStocks.internalStock,
          externalStock: itemStocks.externalStock + itemStocks.otherStock,
          quantity: itemStocks.quantity,
          locationName: location && location.name,
          shipTime: shipTime,
        });
      } else {
        stockBehaviorData = this.model.getStockState({
          internalStock: stockInfo ? stockInfo.stock : 0,
          externalStock: externalTotalStock,
          quantity: this.quantity,
          locationName: location && location.name,
          shipTime: shipTime,
        });
      }

      if (stockBehaviorData.isInStock) {
        stockClass = "in-stock";
      } else if (stockBehaviorData.isInsufficientStock) {
        stockClass = "insufficient-stock";
      } else {
        stockClass = "out-of-stock";
      }

      this.model.set({
        stockBehaviorDataTotalStock: stockBehaviorData.totalStock || 0,
      });

      if (
        !stockBehaviorData.isInStock &&
        typeof stockBehaviorData.internalStock === "number"
      ) {
        loading = false;
      }
      self.updateActions();
      var itemRecordType;
      var itemInfoPDP = this.PDP.getItemInfo();
      if (!itemInfoPDP) {
        if (!this.itemModel) {
          // here we working around some glitch where itemModel is not yet set
          loading = true;
          itemRecordType = "";
        } else if (this.itemModel.item) {
          itemRecordType = this.itemModel.item.itemtype;
        } else {
          itemRecordType = this.itemModel.get("itemtype");
        }
      } else {
        itemRecordType = itemInfoPDP.item.itemtype;
      }
      if (
        recordTypesWithInventory.indexOf(itemRecordType.toLowerCase()) === -1
      ) {
        stockClass = "in-stock";
        stockBehaviorData.behaviour = "In Stock";
        stockBehaviorData.isInStock = true;
        stockBehaviorData.stockDescription = "In stock";
      }

      return {
        totalStock: stockBehaviorData.totalStock || 0,
        stockClass: stockClass,
        stockDescription: stockBehaviorData.stockDescription,
        isInStock: stockBehaviorData.isInStock,
        behavior: stockBehaviorData.behavior,
        loading: loading,
        internalStock: stockBehaviorData.internalStock,
        externalStock: stockBehaviorData.externalStock,
      };
    };

    this.updateActions = function updateActions() {
      var itemInfo = self.PDP.getItemInfo();
      var quantity = itemInfo ? itemInfo.quantity : 1;
      if (!itemInfo) return;
      var itemRecordType = itemInfo.item.itemtype;
      var hidePrice = itemInfo.item.custitem_sdb_item_hide_price;
      if (
        recordTypesWithInventory.indexOf(itemRecordType.toLowerCase()) === -1
      ) {
        self.model.set({
          addToCartEnabled:
            !hidePrice &&
            recordTypesNotPurchasable.indexOf(itemRecordType.toLowerCase()) ===
              -1,
        });
        return;
      }
      self.quantity = quantity;
      var totalStock =
        self.model.get("stockBehaviorDataTotalStock") ||
        self.model.get("totalStock");
      self.model.set({
        addToCartEnabled: totalStock >= quantity && !hidePrice,
      });
    };
    this.model.on(
      "change:totalStock change:linesAndStockHelper",
      function ExternalInventoryViewEvent() {
        try {
          self.updateActions();
          self.render();
        } catch (error) {
          console.error("error in change:totalStock", error);
        }
      },
      this
    );

    if (!this.isCartPage) {
      this.PDP.on("afterQuantityChange", function ExternalInventoryViewEvent() {
        try {
          self.updateActions();
          self.render();
        } catch (error) {
          console.error("error in afterQuantityChange", error);
        }
      });

      this.PDP.on("afterShowContent", function ExternalInventoryViewEvent() {
        self.itemModel = self.PDP.getItemInfo();
      });
    }

    this.listenTo(
      this.LocationsModel,
      "change:location change:shoppingExperience",
      function ExternalInventoryViewEvent(e) {
        if (
          e.changed.shoppingExperience == "instore" ||
          (e.changed.shoppingExperience == "online" &&
            self.LocationsModel.getSelectedLocation())
        )
          return;
        var selectedLocation = self.LocationsModel.get("location");
        // if (typeof selectedLocation === 'string' || typeof selectedLocation === 'undefined') return;
        var selectedLocationName =
          (selectedLocation && selectedLocation.name) || "Fedco";
        selectedLocationName =
          selectedLocationName == "FT. Sask"
            ? "FT. Saskatchewan"
            : selectedLocationName;
        var itemInfo = self.itemModel;
        var item = itemInfo && itemInfo.item;
        if (!item) return;
        var sku = item && item.itemid;
        var group = item && item.custitemrs_brand;
        var data = {
          Group: group,
          GroupIdentifier: sku,
          selectedLocation: selectedLocationName,
          isPDP: true,
        };

        var getInternalStocks = function getInternalStocks(item) {
          var internalStocks = [];
          _.each(map, function (location, locationName) {
            var locationInternal = location.internal;
            var internalStock = item.attributes
              ? item.get(locationInternal) || 0
              : item[locationInternal] || 0;
            if (internalStock == 0) return;
            if (locationName == selectedLocationName.toUpperCase()) return;
            internalStocks.push({
              Location: locationName,
              fieldId: locationInternal,
              internalStock: internalStock,
            });
          });
          return internalStocks;
        };

        var env = this.options.container.getComponent("Environment");
        var map = this.LocationsModel.getFieldMapper(env);
        self.model
          .getExternalInventory([data])
          .then(function () {
            var requiredInternalStock = getInternalStocks(item);
            var itemMissingStock = {
              sku: sku,
              item_id: item.internalid,
              selectedLocation: selectedLocationName,
              quantity: 0,
              askedLocations: JSON.stringify(requiredInternalStock),
              externalLocations: JSON.stringify(
                self.model.get("externalLocationsPDP")
              ),
              isPDP: true,
            };
            self.model
              .getInternalInventory([itemMissingStock])
              .then(function () {
                // self.updateActions();
                // self.render();
              })
              .catch(function (error) {
                console.error(error);
              });
          })
          .catch(function (error) {
            console.error(error);
          });
      }
    );

    this.destroy = _.wrap(this.destroy, function (fn) {
      fn.apply(this, Array.prototype.slice.call(arguments, 1));
      self.unbindEvents(self.PDP);
      self.unbindEvents(self.model);
    });

    this.unbindEvents = function unbindEvents(object) {
      for (var key in object._cancelableEvents) {
        var events = object._cancelableEvents[key];
        var eventsToUnbind = [];
        _.each(events, function (event) {
          if (event.fn.name === "ExternalInventoryViewEvent")
            eventsToUnbind.push(event.fn);
        });
        _.each(eventsToUnbind, function (func) {
          object.off(key, func, object);
        });
      }
    };
  };

  ExternalVendorInveltoryView.prototype = Object.create(SCView.prototype);
  ExternalVendorInveltoryView.prototype.constructor =
    ExternalVendorInveltoryView;

  return ExternalVendorInveltoryView;
});
